








































import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";


@Component
export default class BaseTLTreeCheckView extends Vue {

	@Prop({ type: String, required: false, default: "" }) detailRoute?: string; //route na detail
	@Prop({ type: String, required: false, default: "" }) returnRoute?: string; //route navratu
	@Prop({ type: String, required: false, default: "onlyView" }) typeView?: string; //typ stromu - edit, 

	@Prop({ type: String, required: false, default: "Název" }) label?: string; //hlavní popis
	@Prop({ required: true }) itemData: any;
		@Prop(Boolean) readonly!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) isOpen?: boolean;

	@Prop({ type: Boolean, required: false, default: false }) canDelete?: boolean; //zobrazit tlačitko delete
	@Prop({ type: Boolean, required: false, default: false }) canCreate?: boolean; //zobrazit tlačitko novy
	@Prop({ type: Boolean, required: false, default: false }) canUpdate?: boolean; //zobrazit tlačitko update
	@Prop({ type: Boolean, required: false, default: false }) canRead?: boolean; //zobrazit tlačitko info


	//pouze kdy chceme zrusit nebo zapnout rodice (bez zapnuti/vypnuti potomku)
	changeSelectOne(item: any) {
		item.selected = item.selected;
	}


	changeSelect(item: any) {
	
		this.selected(item, item.selected);

		//TODO zobrazeni mezistavu
		//if (item.idGroup != null) {
		//	this.interSelect(this.getNode(this.itemData, item.idGroup, null));
		//}
	}

	//prolizam dolu
	selected(item: any, selected: boolean) {
		item.selected = selected;

		for (var i = 0; i < item.children.length; i++) {			
			this.selected(item.children[i], selected);
		}
		return true;
	}



	//TODO spatne pracuje mezistav
	//jdu nahoruje jen po uzlech
	//interSelect(item: any) {
	
	//		let parChilSel = item.children.filter(c => c.selected).length;
	//		let parChilCount = item.children.length;

	//		if (parChilCount > 0) {		
	//			item.selected = parChilSel == parChilCount;
	//	}
	

	//	if (item.idGroup != null) {
	//		let itemParent = this.getNode(this.itemData, item.idGroup, null);
	//		this.interSelect(itemParent);
	//	}
	
	//	return true;
	//}



	//nalezení uzlu podle id
	getNode(item: any, id: any, result: any) {

		if (item.id != undefined) {
		
			if (item.id == id) {
				result = item;
				return result;
			}
		}
			for (var i = 0; i < item.children.length; i++) {
				let res = this.getNode(item.children[i], id, result);
				if (res != null) {
					result = res;
				}
			}
		
		return result;
	}


	makeFolder(item: any) {
		Vue.set(item, 'children', [])
		this.addItem(item)
	};

	removeItem(item: any) {

	}

	addItem(item: any) {
		if (item.children == undefined) {
			Vue.set(item, 'children', []);
		}
		item.children.push({
			name: 'nova položka'
		})
	};


	//načtení stylu
	get inputClass() {
		return {

			"label-design-head": true
		};
	}


}
